<template>
  <CustomCreateDialog
      dialogId="user-loyalty-create-modal"
      dialogTitle="افزودن کاربر"
      :isOkDisabled="!isValid || submitting"
      :isLoading="submitting"
      @ok="submit"
      @cancel="cancel"
      width="500px"
      maxWidth="95vw"
      minWidth="300px"
      okTitle="افزودن"
  >
    <b-row>
      <b-col cols="12">
        <div class="f-group">
          <label class="f-label">انتخاب کاربر</label>

          <CustomPicker
              title="fullName"
              inputLabel="جستجو و انتخاب کاربر"
              v-model="form.selectedUserObject"
              :items="users"
              :closeOnSelect="true"
              :disabled="submitting"
              @search="onUserSearch"
          >
            <template #labelOption="option">
              <span dir="rtl" style="text-align:right">
                {{ option.item.fullName }}
                <template v-if="option.item.mobile"> ({{ option.item.mobile }}) </template>
              </span>
            </template>
          </CustomPicker>

          <div v-if="touched && !userValid" class="f-error">لطفا کاربر را انتخاب کنید</div>
        </div>
      </b-col>

      <b-col cols="12" md="6">
        <div class="f-group">
          <label class="f-label">سطح وفاداری</label>

          <v-select
              v-model="form.levelId"
              :options="levels"
              :reduce="(x) => x.id"
              label="name"
              placeholder="انتخاب سطح"
              :disabled="submitting"
              class="v-select-custom"
          >
            <template #option="option">
              <div class="level-opt">
                <LevelAvatarBadge :avatarKey="option.avatar" />
                <div class="level-opt__content">
                  <div class="level-opt__name">{{ option.name }}</div>
                  <div class="level-opt__meta">
                    <span class="meta-tag">اولویت {{ formatNumber(option.priority) }}</span>
                    <span class="meta-tag meta-tag--accent">{{ formatNumber(option.discount) }}%</span>
                  </div>
                </div>
              </div>
            </template>
          </v-select>

          <div v-if="touched && !levelValid" class="f-error">لطفا سطح را انتخاب کنید</div>
        </div>
      </b-col>

      <b-col cols="12" md="6">
        <div class="f-group">
          <label class="f-label">ماه هدف (فقط روز اول ماه)</label>
<!--          <div class="mb-1 text-muted small">تاریخ انتخاب شده: {{ displaySelectedDate }}</div>-->
          <CustomDate
              v-model="form.selectedDate"
              inputId="createTargetDate"
              format="YYYY-MM-DD"
              displayFormat="jYYYY/jMM/jDD"
              inputFormat="jYYYY/jMM/jDD"
              inputPlaceholder="انتخاب ماه"
              :disabled="submitting"
          />


          <div v-if="touched && !dateValid" class="f-error">لطفا ماه را انتخاب کنید (فقط روز اول ماه)</div>
        </div>
      </b-col>

      <b-col cols="12">
        <div class="f-group">
          <label class="f-label">توضیحات</label>

          <b-form-textarea
              v-model.trim="form.description"
              class="f-textarea"
              rows="3"
              placeholder="توضیحات اضافی (اختیاری)..."
              :disabled="submitting"
          />
        </div>
      </b-col>
    </b-row>
  </CustomCreateDialog>
</template>

<script>
import { BRow, BCol, BFormTextarea } from "bootstrap-vue";
import vSelect from "vue-select";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
import CustomDate from "@/views/components/Utils/CustomDatePicker.vue";
import LevelAvatarBadge from "@core/components/loyalty/LevelAvatarBadge.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "CreateUserLoyaltyDialog",
  components: { BRow, BCol, BFormTextarea, vSelect, CustomCreateDialog, CustomPicker, CustomDate, LevelAvatarBadge },
  props: {
    submitting: { type: Boolean, default: false },
    users: { type: Array, default: () => [] },
    levels: { type: Array, default: () => [] },
  },
  data() {
    return {
      touched: false,
      form: {
        selectedUserObject: null,
        levelId: null,
        selectedDate: "",
        description: "",
      },
    };
  },
  computed: {
    userValid() {
      return this.form.selectedUserObject && Number(this.form.selectedUserObject.userId || 0) > 0;
    },
    levelValid() {
      return Number(this.form.levelId || 0) > 0;
    },
    dateValid() {
const jalaliDay = new Date(this.form.selectedDate).toLocaleDateString('fa-IR',{day:'numeric'});
      return +this.convertNumbers2English(jalaliDay) === 1;
    },
    isValid() {
      return this.userValid && this.levelValid;
    },
    displaySelectedDate() {
      if (!this.form.selectedDate) return 'انتخاب نشده';

      const parts = this.form.selectedDate.split('/');
      if (parts.length !== 3) return this.form.selectedDate;

      const persianMonths = [
        'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
        'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
      ];

      const year = parts[0];
      const month = parseInt(parts[1]);
      const monthName = persianMonths[month - 1] || month;

      return `اول ${monthName} ${year}`;
    },
  },
  methods: {
   convertNumbers2English(number) {
  if (number) {
    return number.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
      return c.charCodeAt(0) & 0xf;
    });
  }
},
    formatNumber(value) {
      const num = Number(value || 0);
      try {
        return new Intl.NumberFormat("fa-IR").format(num);
      } catch {
        return String(num);
      }
    },
    disableNotFirstDay(formattedDate, momentDateObj) {
      if (!momentDateObj || !momentDateObj.jDate) {
        return false;
      }

      try {
        const dayOfMonth = momentDateObj.jDate();
        return dayOfMonth !== 1;
      } catch (error) {
        console.error("Error in disableNotFirstDay:", error);
        return false;
      }
    },

    reset() {
      this.touched = false;
      this.form = {
        selectedUserObject: null,
        levelId: null,
        selectedDate: "",
        description: ""
      };
    },

    cancel() {
      this.reset();
      this.$emit("cancel");
    },

    submit() {
      this.touched = true;
      if (!this.isValid || this.submitting) return;

      try {
        if (!this.dateValid) {
          this.$toast({
            component: ToastificationContent,
            props: { title: "لطفا ماه را انتخاب کنید (فقط روز اول ماه)", icon: "AlertTriangleIcon", variant: "danger" },
          });
          return;
        }
        const payload = {
          userId: Number(this.form.selectedUserObject.userId),
          levelLoyaltId: Number(this.form.levelId),
          targetDate: this.form.selectedDate, // تاریخ شمسی: "1404/11/01"
          description: String(this.form.description || ""),
        };

        console.log("ارسال به صفحه اصلی (شمسی):", payload);
        this.$emit("submit", payload);

      } catch (error) {
        console.error("Error in submit:", error);
        this.$toast({
          component: ToastificationContent,
          props: { title: "خطا در پردازش تاریخ", icon: "AlertTriangleIcon", variant: "danger" },
        });
      }
    },

    onUserSearch(searchValue, loadingFn) {
      this.$emit("userSearch", searchValue, loadingFn);
    },

    showToast(variant, title, text) {
      this.$toast({
        component: window.ToastificationContent,
        position: "bottom-center",
        props: { title, text, icon: "", variant },
      });
    }
  },
};
</script>

<style scoped>
.f-group {
  margin-bottom: 16px;
}
.f-label {
  font-size: 12px;
  font-weight: 900;
  color: #374151;
  margin-bottom: 8px;
  display: block;
}
.f-error {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #dc2626;
}
.f-textarea {
  border-radius: 14px;
  border: 2px solid #e5e7eb;
  font-weight: 600;
  font-size: 14px;
  padding: 12px 16px;
  transition: all 0.2s ease;
  resize: vertical;
}
.f-textarea:focus {
  border-color: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.08);
}
.level-opt {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 4px;
}
.level-opt__content {
  flex: 1;
  min-width: 0;
}
.level-opt__name {
  font-size: 13px;
  font-weight: 900;
  color: #111827;
  margin-bottom: 4px;
}
.level-opt__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.meta-tag {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 8px;
  background: rgba(107, 114, 128, 0.08);
  font-size: 11px;
  font-weight: 800;
  color: #4b5563;
}
.meta-tag--accent {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(16, 185, 129, 0.1));
  color: #16a34a;
}
.v-select-custom :deep(.vs__dropdown-toggle) {
  height: 48px;
  border-radius: 14px;
  border: 2px solid #e5e7eb;
  padding: 0 12px;
}
</style>